import { Box, Circle, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

import useViewport from "hooks/useViewport";
import { InitialUseCreateModalType, useCreateModal } from "../ModalsProvider";
import IconFacebook from "components/Chakra/Icons/Facebook";
import IconLink2 from "components/Chakra/Icons/Link2";
import IconMessenger from "components/Chakra/Icons/Messenger";
import IconTwitter from "components/Chakra/Icons/Twitter";
import { DetailData } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";

type ShareModalProps = {
  offer?: DetailData;
};

// TODO fix absoluteURL

const ShareModal: React.FC<ShareModalProps> = ({ offer }) => {
  const { isLargerThanDesktop } = useViewport();

  if (!offer) {
    return null;
  }

  const handleFacebookShare = (): void => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      offer?.absoluteUrl ?? "",
    )}`;

    typeof window !== "undefined" && window.open(url, "facebook");
  };
  const handleMessengerShare = (): void => {
    const appId = "712065129411100";
    const mobileUrl = `fb-messenger://share?link=${encodeURIComponent(
      offer.absoluteUrl ?? "",
    )}&app_id=${appId}`;
    const desktopUrl = `http://www.facebook.com/dialog/send?app_id=${appId}&link=${encodeURIComponent(
      offer.absoluteUrl ?? "",
    )}&redirect_uri=${encodeURIComponent(offer.absoluteUrl ?? "")}`;
    typeof window !== "undefined" &&
      window.open(isLargerThanDesktop ? desktopUrl : mobileUrl, "facebook");
  };

  const handleTwitterShare = (): void => {
    const text = "Úžasný byt! ";
    let url = "http://twitter.com/share?";
    url += "text=" + encodeURIComponent(text);
    url += "&";
    url += "url=" + encodeURIComponent(offer.absoluteUrl ?? ""); // TODO fix

    typeof window !== "undefined" && window.open(url, "twitter");
  };

  const handleCopy = (event: React.MouseEvent): void => {
    event.stopPropagation();
    typeof window !== "undefined" &&
      window.navigator.clipboard.writeText(offer?.absoluteUrl ?? ""); // TODO fix
  };

  return (
    <Box textAlign="center">
      <Stack mb="30px">
        <Heading as="h3" color="ud-grey-600">
          Sdílejte byt mezi přátele
        </Heading>
        <Text textAlign="center" variant="large_2">
          Pronájem {offer.title}
        </Text>
      </Stack>

      <Stack direction="row" justify="center" mb="36px" spacing="8px">
        <Circle
          as="button"
          size="70px"
          onClick={handleFacebookShare}
          backgroundColor="#344d97"
          transition="all 0.3s"
          _hover={{ backgroundColor: "#263c80" }}
        >
          <IconFacebook fillWith="white" boxSize="40px" />
        </Circle>
        <Circle
          as="button"
          onClick={handleMessengerShare}
          size="70px"
          backgroundColor="#006aff"
          transition="all 0.3s"
          _hover={{ backgroundColor: "#0958c7" }}
        >
          <IconMessenger fillWith="white" boxSize="40px" />
        </Circle>
        <Circle
          as="button"
          size="70px"
          onClick={handleTwitterShare}
          backgroundColor="#1a8fe8"
          transition="all 0.3s"
          _hover={{ backgroundColor: "#1579c5" }}
        >
          <IconTwitter fillWith="white" boxSize="40px" />
        </Circle>
      </Stack>

      <Stack
        as="button"
        onClick={(e) => handleCopy(e)}
        direction="row"
        spacing="10px"
        justify="center"
        w="100%"
      >
        <IconLink2 boxSize="20px" fillWith="ud-grey-600" />
        <Text align="center">www.ulovdomov.cz/inzerat/…</Text>
      </Stack>
    </Box>
  );
};

export const useShareModal: InitialUseCreateModalType<ShareModalProps> = () =>
  useCreateModal("shareModal", ShareModal as React.FC, null, null, {
    size: "md",
    variant: "primary",
  });
